import { useMemo } from 'react';

import type { Option } from '@packages/components/controls/controlled-select-v2/controlled-select-v2';
import { createOptions } from '@packages/utils/create-options/create-options';

const minutesOptions = [5, 30, 60, 120];

export const useScanPeriodOptions = (): Option[] => {
  return useMemo(() => {
    const options: [string, string][] = Object.values(minutesOptions).map(
      (value) => [`${value}`, `${value} minutes`],
    );
    return createOptions(options);
  }, []);
};
